/**
 * branch-policy.ts - 지점 정책(BranchPolicy) Firestore 서비스
 *
 * 경로: users/{ownerUid}/centers/{centerId}/branchPolicy/default
 */

import { doc, getDoc, setDoc } from "firebase/firestore";
import { getFirebaseFirestore } from "@/config/firebase";
import type { BranchPolicy } from "@vlab-corporation/vlab-pilates-service-interface/branch";

export type { BranchPolicy };

/** BranchPolicy 기본값 (문서가 없을 때 사용) */
const DEFAULT_BRANCH_POLICY: BranchPolicy = {
  membershipPricing: [],
  instructorPayScale: [],
  journalFormat: { enabled: false },
};

/**
 * 지점 정책을 Firestore에서 조회한다.
 * 문서가 없으면 기본값을 반환한다.
 *
 * @param ownerUid - 센터 소유자 UID
 * @param centerId - 센터 ID
 * @returns BranchPolicy
 */
export async function getBranchPolicy(ownerUid: string, centerId: number): Promise<BranchPolicy> {
  const ref = doc(
    getFirebaseFirestore(),
    "users",
    ownerUid,
    "centers",
    String(centerId),
    "branchPolicy",
    "default",
  );
  const snap = await getDoc(ref);
  if (!snap.exists()) return { ...DEFAULT_BRANCH_POLICY };
  return snap.data() as BranchPolicy;
}

/**
 * 지점 정책을 Firestore에 저장한다.
 *
 * @param ownerUid - 센터 소유자 UID
 * @param centerId - 센터 ID
 * @param policy - 저장할 BranchPolicy
 */
export async function saveBranchPolicy(
  ownerUid: string,
  centerId: number,
  policy: BranchPolicy,
): Promise<void> {
  const ref = doc(
    getFirebaseFirestore(),
    "users",
    ownerUid,
    "centers",
    String(centerId),
    "branchPolicy",
    "default",
  );
  await setDoc(ref, policy);
}
